import { useEffect, useRef, useState } from "react"
import { UserApi } from "../../api/User.api";
import UserSubscription from "../../models/UserSubscription.model";
import { AdditionalPaymentType, Product, Products } from "../../commons/Const";
import Error from "../../models/Error.model";
import { useAppSelector } from "../../store";
import moment from "moment";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { PaymentApi } from "../../api/Payment.api";

export type AdditionalPayment = {
  type: number,
  userId: number
  productId: number
  productName: string|null
  userSubscriptionId: number
  month: number
  amount: number
  expiredAt: Date
  userSubscription: UserSubscription,
  startRound: number
}

export default function PaymentViewModel() {

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const user = useAppSelector(state => state.app.user);

  const [additionalPayment, setAdditionalPayment] = useState<AdditionalPayment|null>(null);

  const [product, setProduct] = useState<Product|null>(null)
  const [payMethod, setPayMethod] = useState(0);
  const [subscriptionPeriod, setSubscriptionPeriod] = useState('');

  const uuidRef = useRef<string|null>(null);

  useEffect(() => {
    const uuid = searchParams.get('uuid');
    if(user === undefined || uuid === null) return;

    if(user === null) { //로그인 필요
      navigate({
        pathname: '/signin',
        search: createSearchParams({
          uuid
        }).toString()
      });
    }
    else {

      uuidRef.current = uuid;

      getPayment(uuid);
    }
  }, [user, searchParams]);

  const getPayment = async (uuid: string) => {
    try {
      const result = await UserApi.getPayment(uuid);

      setProduct(Products.find(v => v.id === result.productId) ?? null);
      setAdditionalPayment(result);

      if(result.userSubscriptionId !== -1) {
        const startMoment = moment(result.userSubscription.createdAt);

        if(process.env.REACT_APP_MODE === 'production') {
          startMoment.set({hours: 0, minutes: 0, seconds: 0, milliseconds: 0});
          setSubscriptionPeriod(`${startMoment.clone().add(result.startRound - 1, 'months').format('YYYY.MM.DD')} ~ ${startMoment.clone().add(result.startRound - 1 + result.month, 'months').subtract(1, 'days').format('YYYY.MM.DD')}(${result.month}개월)`)
        }
        else {
          startMoment.set({seconds: 0, milliseconds: 0})
          setSubscriptionPeriod(`${startMoment.clone().add((result.startRound - 1) * 10, 'minutes').format('YYYY.MM.DD HH:mm')} ~ ${startMoment.clone().add((result.startRound - 1 + result.month) * 10, 'minutes').subtract(1, 'minutes').format('YYYY.MM.DD HH:mm')}(${result.month * 10}분)`)
        }
      }

    } catch (error) {
      console.log(error);
      if(error instanceof Error) {
        alert(error.message);
      }
      //navigate('/')
    }
  }

  const order = async () => {

    if(additionalPayment === null) return;  
    if(user === undefined || user === null) return;
    
    if(uuidRef.current === null) return;

    try {

      const {type, productId, productName, month, amount, userSubscription, startRound} = additionalPayment;

      const product = Products.find(v => v.id === productId);

      if(product === undefined) return;

      let paymentData: any = {};

      if(type === AdditionalPaymentType.EXTENSION_SUBSCRIPTION) { //기존 구독 연장 결제
        paymentData = {
          pg: process.env.REACT_APP_PG_CARD,
          pay_method : 'card',
          merchant_uid : `${user.phone}-${new Date().getTime()}`,
          name : product.name,
          amount : amount,
          buyer_name : user.name,
          buyer_tel : user.phone,
          customer_uid: `sellerguard-stage-${user.phone}`,
          custom_data: {
            month, type, startRound
          },  
          period : {
            from : moment(userSubscription.createdAt).add(startRound - 1, 'months').format('YYYYMMDD'), //YYYYMMDD
            to : moment(userSubscription.createdAt).add(startRound - 1 + month, 'months').subtract(1, 'day').format('YYYYMMDD')
          }
        }
      }
      else {
        paymentData = {
          pg: payMethod === 0 ? process.env.REACT_APP_PG_CARD : process.env.REACT_APP_PG_PHONE,
          pay_method : payMethod === 0 ? 'card' : 'phone',
          merchant_uid : `${user.phone}-${new Date().getTime()}`,
          name : productName,
          amount : amount,
          buyer_name : user.name,
          buyer_tel : user.phone,
          custom_data: {
            type
          },  
        }
      }

      const paymentResult = await createPayment(paymentData);

      const result = await UserApi.additionalPayment({
        uuid: uuidRef.current,
        productId: additionalPayment.productId,
        payMethod: payMethod,
        data: paymentResult
      });

      navigate('/payment/complete', {state: result});

    } catch (error) {
      console.error(error)
    }
  }

  const createPayment = async (data: any): Promise<any> => {

    return new Promise((resolve, reject) => {
      const { IMP } = window
      IMP.init("imp84428497");

      IMP.request_pay(data, (response: any) => {
        if(response.success) {
          resolve(response);
        }
        else {
          reject(response);
        }
      });
    })
  }

  return {
    user,
    additionalPayment, getPayment,
    subscriptionPeriod,
    product, payMethod, setPayMethod,
    order
  }
}